import { Box, styled } from "@mui/material";
import MentorsCard from "./MentorsCard";
import { mentorsInfo } from "./BizdevInternshipData";
import Slider from "react-slick";

const OurMentors = () => {
  const sliderSettings = {
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 5000,
    pauseOnHover: true,
    initialSlide: 0,
    slidesToShow: 3.9,
    slidesToScroll: 0.5,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3.3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2.8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 799,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.09,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Root>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <Header>Our Mentors</Header>
        <SubHeader>You won't do this alone.</SubHeader>{" "}
      </Box>
      <Content>
        <Slider {...sliderSettings}>
          {mentorsInfo?.map((el, i) => (
            <MentorsBox key={i}>
              <MentorsCard image={el.image} name={el.name} role={el.role} />
            </MentorsBox>
          ))}
        </Slider>
      </Content>
    </Root>
  );
};

export default OurMentors;

const Root = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "80px",
  [theme.breakpoints.down(500)]: {
    gap: "31px",
  },
}));

const Header = styled("h2")(({ theme }) => ({
  textAlign: "center",
  width: "831px",
  margin: "auto",
  fontSize: "48px",
  lineHeight: 1.33,
  fontWeight: 700,
  [theme.breakpoints.down(900)]: {
    width: "100%",
    paddingInline: "20px",
    fontSize: "35px",
    lineHeight: 1.3,
  },
  [theme.breakpoints.down(500)]: {
    fontSize: "24px",
    lineHeight: "35px",
  },
}));

const SubHeader = styled("h4")(({ theme }) => ({
  textAlign: "center",
  margin: "auto",
  fontSize: "20px",
  lineHeight: "22px",
  fontWeight: 400,
}));

const Content = styled("div")(({ theme }) => ({
  padding: "0 0 0 64px",
  margin: "auto",
  maxWidth: "1440px",
  height: "fit-content",
  [theme.breakpoints.down(900)]: {
    padding: "0 0 0px 0px",
    width: "100%",
  },
  [theme.breakpoints.down(1200)]: {
    maxWidth: "1200px",
  },
}));

const MentorsBox = styled("div")(({ theme }) => ({
  width: 340,
  paddingLeft: "20px",
  [theme.breakpoints.down(900)]: {
    paddingLeft: "16px",
  },
}));
